const aplCatlCode = {
    PON4300: '650',
    CONTACT: '631',
    POLICY: '640',
    MULTI_ENOTIFY: '670',
    MULTI_PAY_CHANGE: '700',
    ACH: '720',
    CREDIT_CARD_EXP: '710',
    CREDIT_CARD_AUTH: '730',
    RESERVE_VIDEO: 'ReserveVideo',
    BENEIFCIARY: '110',
    APPLICANT_CHANGE: '120',
    APPLICANT_INSURED_NAME_CHANGE: '130',
    LOAN: '100',
    LINEPNP: '990',
};

Object.freeze(aplCatlCode);
export default aplCatlCode;
